<script>
import { settings } from '../variables';

export default {

  data () {
    return {
      ymCounterId: settings.ymCounterId
    }
  },

  methods: {
    isLetter: function (e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if(/^[A-Za-zА-Яа-я ]+$/.test(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    },

    padTo2Digits: function (num) {
      return num.toString().padStart(2, '0')
    },

    formatDate: function (date) {
      if (!date) {
        return null
      }
      try {
        return [
          date.getFullYear(),
          this.padTo2Digits(date.getMonth() + 1),
          this.padTo2Digits(date.getDate()),
          ].join('-')
      }
      catch (e) {
        return date
      }

    }
  }
}
</script>